import i18next from 'i18n';
import React from 'react';
import Countdown from 'react-countdown';

export type IBidTimerProps = {
    dueDate: Date;
};

const BidTimer = (props: IBidTimerProps) => {
    const { dueDate } = props;
    return (
        <div>
            <Countdown
                date={dueDate}
                renderer={({ days, hours, minutes, seconds }) => {
                    if (days > 0) {
                        return (
                            <div suppressHydrationWarning>
                                {days}{i18next.t('item-text.first-letter-of-day')} {hours}{i18next.t('item-text.first-letter-of-hours')}
                            </div>
                        );
                    }
                    if (hours > 0) {
                        return (
                            <div className="text-red" suppressHydrationWarning>
                                {hours}{i18next.t('item-text.first-letter-of-hours')} {minutes}{i18next.t('item-text.first-letter-of-minutes')}
                            </div>
                        );
                    }
                    return (
                        <div className="text-red" suppressHydrationWarning>
                            {minutes}{i18next.t('item-text.first-letter-of-minutes')} {seconds}{i18next.t('item-text.first-letter-of-seconds')}
                        </div>
                    );
                }}
            />
        </div>
    );
};

export default BidTimer;
